<template>
    <div v-if="show">
        <!-- Top -->
        <div class="head border-b border-t py-[10px] px-[20px] bg-blue-700 border-gray-400">
            <div class="text-white xl:mx-auto font-bold">
                <div>車體損失險</div>
            </div>
        </div>
        <!-- / Top -->

        <div class="pb-6">
            <!-- Head -->
            <div class="bg-blue-200 py-[10px] px-[20px]">
                <div class="flex text-black justify-between xl:mx-auto font-bold">
                    <div>險種名稱 / 保障內容</div>
                    <div>保額</div>
                </div>
            </div>
            <!-- /Head -->

            <!-- Body -->
            <div class="px-[20px] pt-8">
                <!-- 車體損失險 -->
                <div class="xl:mx-auto">
                    <div class="font-bold">
                        車體損失險
                    </div>

                    <div
                        v-if="!insures['198']"
                        class="inline-block mt-5 bg-gray-400 text-gray-600"
                    >
                        折舊率：{{ depreciateText }}
                    </div>

                    <!-- 01 甲式 -->
                    <template v-if="insures['01']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`01 ${ $store.state.ins01.name }`"
                                :price="ins01DamageCover"
                                @click="onClickShowInsInfo('01')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins01Deduct }}</div>
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['01'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['01'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['01'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 01 甲式 -->

                    <!-- 05 乙式-->
                    <template v-if="insures['05']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`05 ${ $store.state.ins05.name }`"
                                :price="ins05DamageCover"
                                @click="onClickShowInsInfo('05')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins05Deduct }}</div>
                            </div>
                            <!-- Price -->
                            <div
                                class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end"
                            >
                                <div
                                    v-if="insures['05'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['05'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['05'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 05 乙式-->

                    <!-- 09 丙式 -->
                    <template v-if="insures['09']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`09 ${ $store.state.ins09.name }`"
                                :price="ins09DamageCover"
                                @click="onClickShowInsInfo('09')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                免自負額
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['09'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['09'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['09'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 09 丙式 -->

                    <!-- 198 限額車碰車對撞 -->
                    <template v-if="insures['198']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`198 ${ $store.state.ins198.name }`"
                                :price="ins198DamageCover"
                                @click="onClickShowInsInfo('198')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                免自負額
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['198'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['198'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['198'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 198 限額車碰車對撞 -->

                    <!-- 201 甲式 -->
                    <template v-if="insures['201']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`201 ${ $store.state.ins201.name }`"
                                :price="ins01DamageCover"
                                @click="onClickShowInsInfo('201')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins201Deduct }}</div>
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['201'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['201'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['201'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 201 甲式 -->

                    <!-- 205 乙式-->
                    <template v-if="insures['205']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`205 ${ $store.state.ins205.name }`"
                                :price="ins205DamageCover"
                                @click="onClickShowInsInfo('205')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins205Deduct }}</div>
                            </div>
                            <!-- Price -->
                            <div
                                class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end"
                            >
                                <div
                                    v-if="insures['205'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['205'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['205'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 205 乙式-->

                    <!-- 209 丙式 -->
                    <template v-if="insures['209']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`209 ${ $store.state.ins209.name }`"
                                :price="ins209DamageCover"
                                @click="onClickShowInsInfo('209')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                免自負額
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['209'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['209'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['209'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 209 丙式 -->

                    <!-- 110 -->
                    <template v-if="insures['110']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`110 ${ $store.state.ins110.name }`"
                                @click="onClickShowInsInfo('110')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 保單賠償上限 </div>
                                <div> {{ ins110DamageCover }} </div>
                            </div>
                        </div>
                    </template>
                    <!-- / 110 -->
                    <!-- 111 -->
                    <template v-if="insures['111']">
                        <div class="mt-6">
                            <FormInfoInsText 
                                :text="`111 ${ $store.state.ins111.name }`"
                                @click="onClickShowInsInfo('111')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 保單賠償上限 </div>
                                <div> {{ ins111DamageCover }} </div>
                            </div>

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="isPreview && insures['110'].IndirectPrem && insures['111'].IndirectPrem"
                                    class="text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄{{ group08Price }}
                                </div>
                                <div class="text-pink-800 text-right">
                                    網路優惠價＄{{ group08SalePrice }}
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 111 -->
                </div>
                <!-- / 車體損失險 -->

                <div
                    v-if="showAdditional"
                    class="bg-blue-400 mt-2 mb-4 p-[20px] rounded-2xl xl:mx-auto"
                >
                    <div class="flex items-center justify-between xl:mx-auto">
                        <div class="my-1 text-[16px] text-blue-700 font-bold">
                            附加險
                        </div>
                    </div>

                    <!-- 161 限額特定車損 -->
                    <template v-if="insures['161']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`161 ${ $store.state.ins161.name }`"
                                :price="ins161DamageCover"
                                @click="onClickShowInsInfo('161')"
                            />
                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['161'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['161'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['161'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 161 限額特定車損 -->

                    <!-- 176 電池自燃附加條款-->
                    <template v-if="insures['176']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`176 ${ $store.state.ins176.name }`"
                                :price="ins176DamageCover"
                                @click="onClickShowInsInfo('176')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins176Deduct }}</div>
                            </div>
                            <!-- Price -->
                            <div
                                class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end"
                            >
                                <div
                                    v-if="insures['176'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['176'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['176'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 176 電池自燃附加條款-->

                    <!-- 177 充電期間附加條款-財產損失保險金-->
                    <template v-if="insures['177']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`177 ${ $store.state.ins177.name }`"
                                :price="ins177DamageCover"
                                @click="onClickShowInsInfo('177')"
                            />
                            <div class="flex justify-between items-center mt-5">
                                <div> 自負額 </div>
                                <div> {{ ins177Deduct }}</div>
                            </div>
                            <!-- Price -->
                            <div
                                class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end"
                            >
                                <div
                                    v-if="insures['177'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['177'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['177'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 177 充電期間附加條款-財產損失保險金-->

                    <!-- 02 颱風地震洪水險 -->
                    <template v-if="insures['02']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`02 ${ $store.state.ins02.name }`"
                                price="同車體險"
                                @click="onClickShowInsInfo('02')"
                            />

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['02'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['02'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['02'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                        <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 02 颱風地震洪水險 -->

                    <!-- 07 車體全損理賠無折舊 -->
                    <template v-if="insures['07']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`07 ${ $store.state.ins07.name }`"
                                price="同車體險"
                                @click="onClickShowInsInfo('07')"
                            />

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['07'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['07'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['07'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 07 車體全損理賠無折舊 -->

                    <!-- 10 車體許可免追償 -->
                    <template v-if="insures['10']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`10 ${ $store.state.ins10.name }`"
                                price="同車體險"
                                @click="onClickShowInsInfo('10')"
                            />
                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['10'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['10'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['10'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                        <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 10 車體許可免追償 -->

                    <!-- 62 甲式車體代車費 -->
                    <template v-if="insures['62']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`62 ${ $store.state.ins62.name }`"
                                :price="ins62DamageCover"
                                @click="onClickShowInsInfo('62')"
                            />
                            <!-- 每一意外事故 -->
                            <div class="flex justify-between mt-6">
                                <div> 每日 1,000 元 </div>
                                <div> {{ ins62QDay }}天 </div>
                            </div>
                            <!-- / 每一意外事故 -->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['62'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['62'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['62'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                        <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 62 甲式車體代車費 -->

                    <!-- 63 乙式車體代車費 -->
                    <template v-if="insures['63']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`63 ${ $store.state.ins63.name }`"
                                :price="ins63DamageCover"
                                @click="onClickShowInsInfo('63')"
                            />
                            <!-- 每一意外事故 -->
                            <div class="flex justify-between mt-6">
                                <div> 每日 1,000 元 </div>
                                <div> {{ ins63QDay }}天 </div>
                            </div>
                            <!-- / 每一意外事故 -->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['63'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['63'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['63'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                        <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 63 乙式車體代車費 -->

                    <!-- 64 丙式車體代車費 -->
                    <template v-if="insures['64']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`64 ${ $store.state.ins64.name }`"
                                :price="ins64DamageCover"
                                @click="onClickShowInsInfo('63')"
                            />
                            <!-- 每一意外事故 -->
                            <div class="flex justify-between mt-6">
                                <div> 每日 1,000 元 </div>
                                <div> {{ ins64QDay }}天 </div>
                            </div>
                            <!-- / 每一意外事故 -->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['64'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['64'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['64'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                        <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 64 丙式車體代車費 -->
                </div>
                <!-- / Body -->
            </div>
            <!-- / 附加險 -->
        </div>
    </div>
</template>

<script>
import FormInfoInsText from '@/components/forms/InfoInsText';
/**
  * 查看詳細內容-車體損失險
 */
export default {
    name: 'PolicyViewCarDamageInsurance',
    components: { FormInfoInsText },
    props: {
        /**
         * 已投保項目
         */
        carInsures: {
            type: Array,
            default: () => {
                return [];
            }
        },
        /**
         * 是否已經試算
         */
        isCalculated: {
            type: Boolean,
            default: false
        },
        /**
         * 折舊率
         */
        depreciateValue: {
            type: String,
            default: 'P'
        }
    },
    emits: ['showInsInfo'],
    data() {
        /**
         * @param {Object} depreciate 折舊率
         * @param {Object} insures 有投保的險種
         * @param {Boolean} show 是否顯示此區塊
         * @param {Boolean} showAdditional 是否顯示附加險
         */
        return {
            depreciate: {
                text: '',
                value: ''
            },
            insures: {
                '01': null,
                '05': null,
                '09': null,
                '198': null,
                '161': null,
                '02': null,
                '07': null,
                '10': null,
                '62': null,
                '63': null,
                '64': null,
                '201': null,
                '205': null,
                '209': null,
                '176': null,
                '177': null,
                '110': null,
                '111': null,
            },
            show: false,
            showAdditional: false,
        };
    },
    computed: {
        // 折舊率
        depreciateText() {
            return this.depreciate.text;
        },
        // ins01 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins01DamageCover() {
            return this.insures['01'] ? this.$monetary.convertToChineseUnit(this.insures['01'].DamageCover) : null;
        },
        // 01 車體損失險-甲式
        ins01Deduct() {
            if (this.insures['01']) {
                return this.$insurance.getCoverText(this.$store.getters['ins01/deductOptionsValid'], this.insures['01'].Deduct.toString(), '01');
            } else {
                return null;
            }
        },
        // ins05 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins05DamageCover() {
            return this.insures['05'] ? this.$monetary.convertToChineseUnit(this.insures['05'].DamageCover) : null;
        },
        // 05 車體損失險-乙式
        ins05Deduct() {
            if (this.insures['05'] !== null) {
                return this.$insurance.getCoverText(this.$store.getters['ins05/deductOptionsValid'], this.insures['05'].Deduct.toString(), '05');
            } else {
                return null;
            }
        },
        // ins09 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins09DamageCover() {
            return this.insures['09'] ? this.$monetary.convertToChineseUnit(this.insures['09'].DamageCover) : null;
        },
        // ins62 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins62DamageCover() {
            return this.insures['62'] ? this.$monetary.convertToChineseUnit(this.insures['62'].DamageCover) : null;
        },
        // 62 甲式車體代車費
        ins62QDay() {
            if (this.insures['62']) {
                return this.insures['62'].DamageCover / this.insures['62'].InjuredCover;
            } else {
                return null;
            }
        },
        // ins63 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins63DamageCover() {
            return this.insures['63'] ? this.$monetary.convertToChineseUnit(this.insures['63'].DamageCover) : null;
        },
        // 63 乙式車體代車費
        ins63QDay() {
            if (this.insures['63']) {
                return this.insures['63'].DamageCover / this.insures['63'].InjuredCover;
            } else {
                return null;
            }
        },
        // ins64 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins64DamageCover() {
            return this.insures['64'] ? this.$monetary.convertToChineseUnit(this.insures['64'].DamageCover) : null;
        },
        // 64 丙式車體代車費
        ins64QDay() {
            if (this.insures['64']) {
                return this.insures['64'].DamageCover / this.insures['64'].InjuredCover;
            } else {
                return null;
            }
        },
        // 161 限額特定車損
        ins161DamageCover() {
            if (this.insures['161']) {
                let insure = this.$insurance.getCoverText(this.$store.getters['ins161/damageCoverOptionsValid'], this.insures['161'].DamageCover.toString());
                return insure ? insure.text : this.insures['161'].DamageCover;
            } else {
                return null;
            }
        },
        // ins198 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins198DamageCover() {
            return this.insures['198'] ? this.$monetary.convertToChineseUnit(this.insures['198'].DamageCover) : null;
        },
        // 依據是否試算過，顯示「網路優惠價」或「參考價」字樣
        priceText() {
            return this.isCalculated ? '網路優惠價' : '參考價';
        },
        // ins201 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins201DamageCover() {
            return this.insures['201'] ? this.$monetary.convertToChineseUnit(this.insures['201'].DamageCover) : null;
        },
        // 01 車體損失險-甲式
        ins201Deduct() {
            if (this.insures['201']) {
                return this.$insurance.getCoverText(this.$store.getters['ins201/deductOptionsValid'], this.insures['201'].Deduct.toString());
            } else {
                return null;
            }
        },
        // ins205 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins205DamageCover() {
            return this.insures['205'] ? this.$monetary.convertToChineseUnit(this.insures['205'].DamageCover) : null;
        },
        // 05 車體損失險-乙式
        ins205Deduct() {
            if (this.insures['205'] !== null) {
                return this.$insurance.getCoverText(this.$store.getters['ins205/deductOptionsValid'], this.insures['205'].Deduct.toString());
            } else {
                return null;
            }
        },
        // ins209 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins209DamageCover() {
            return this.insures['209'] ? this.$monetary.convertToChineseUnit(this.insures['209'].DamageCover) : null;
        },
        // 110
        ins110DamageCover() {
            if (this.insures['110'].DamageCover) {
                return this.$insurance.getCoverText(this.$store.getters['ins110/damageCoverOptionsValid'], this.insures['110'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 111
        ins111DamageCover() {
            if (this.insures['111'].DamageCover) {
                return this.$insurance.getCoverText(this.$store.getters['ins111/damageCoverOptionsValid'], this.insures['111'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 110 111 定價
        group08Price() {
            let price = this.insures['110'].IndirectPrem + this.insures['111'].IndirectPrem;
            return this.$monetary.convertToLocaleString(price);
        },
        // 110 111 網路優惠價
        group08SalePrice() {
            let price = this.insures['110'].InsPremium + this.insures['111'].InsPremium;
            return this.$monetary.convertToLocaleString(price);
        },
        // ins176 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins176DamageCover() {
            return this.insures['176'] ? this.$monetary.convertToChineseUnit(this.insures['176'].DamageCover) : null;
        },
        // 176 電池自燃附加條款 
        ins176Deduct() {
            if (this.insures['176']) {
                return this.$insurance.getCoverText(this.$store.getters['ins176/deductOptionsValid'], this.insures['176'].Deduct.toString());
            } else {
                return null;
            }
        },
        // ins177 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins177DamageCover() {
            return this.insures['177'] ? this.$monetary.convertToChineseUnit(this.insures['177'].DamageCover) : null;
        },
        // 177 充電期間附加條款-財產損失保險金
        ins177Deduct() {
            if (this.insures['177']) {
                return this.$insurance.getCoverText(this.$store.getters['ins177/deductOptionsValid'], this.insures['177'].Deduct.toString());
            } else {
                return null;
            }
        },
    },
    mounted() {
        // 顯示線上投保成功的內容
        this.setContent();

        let depreciateValue = this.depreciateValue;
        if (this.insures['01'] && this.insures['01'].Provision ) {
            // 如選擇01車體損失險-甲式，顯示對應的折舊率
            depreciateValue = this.insures['01'].Provision[0] || '';
        } else if (this.insures['05'] && this.insures['05'].Provision ) {
            // 如選擇05車體損失險-乙式，顯示對應的折舊率
            depreciateValue = this.insures['05'].Provision[0] || '';
        } else if (this.insures['09'] && this.insures['09'].Provision ) {
            // 如選擇09車體損失險-丙式，顯示對應的折舊率
            depreciateValue = this.insures['09'].Provision[0] || '';
        } else if (this.insures['198'] && this.insures['198'].Provision ) {
            // 如選擇198限額車對車碰撞損失保險，顯示對應的折舊率
            depreciateValue = this.insures['198'].Provision[0] || '';
        } else if (this.insures['201'] && this.insures['201'].Provision ) {
            // 如選擇201車體損失險-甲式，顯示對應的折舊率
            depreciateValue = this.insures['201'].Provision[0] || '';
        } else if (this.insures['205'] && this.insures['205'].Provision ) {
            // 如選擇205車體損失險-乙式，顯示對應的折舊率
            depreciateValue = this.insures['205'].Provision[0] || '';
        } else if (this.insures['209'] && this.insures['209'].Provision ) {
            // 如選擇209車體損失險-丙式，顯示對應的折舊率
            depreciateValue = this.insures['209'].Provision[0] || '';
        }

        this.depreciate = _.find(this.$store.state.options.depreciate, { value: depreciateValue });
        if(this.insures['161'] || this.insures['176'] || this.insures['177'] || this.insures['02'] || this.insures['07'] || this.insures['10'] || this.insures['62'] || this.insures['63'] || this.insures['64']) {
            this.showAdditional = true;
        }
    },
    methods: {
        /**
         * 顯示線上投保成功的內容
         * 
         * @public
         */
        setContent() {
            _.forIn(this.insures, (value, key) => {
                this.insures[key] = _.find(this.carInsures, {InsType: key});
                if (this.insures[key]) this.show = true;
            });
        },
        /**
         * 顯示險種介紹（有代碼的險種說明）
         * 
         * @param {String} insType 險種
         * @public
         */
        onClickShowInsInfo(insType) {
            /**
             * 顯示險種介紹（有代碼的險種說明）
             * @property {String} insType 險種
             */
            this.$emit('showInsInfo', insType);
        }
    }
};
</script>
